export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/beta_reading.a20644f.svg";